import { useState } from "react";
import { useNavigate, Link } from "react-router-dom";
import { toast } from "sonner";
import { Loader2, Lock } from "lucide-react";
import { Button } from "@/components/ui/button";
import { Input } from "@/components/ui/input";
import { Label } from "@/components/ui/label";
import { api, setToken } from "@/lib/api";

const AdminLogin = () => {
  const nav = useNavigate();
  const [email, setEmail] = useState("");
  const [password, setPassword] = useState("");
  const [loading, setLoading] = useState(false);

  const submit = async (e) => {
    e.preventDefault();
    setLoading(true);
    try {
      const res = await api.post("/auth/login", { email, password });
      setToken(res.data.access_token);
      toast.success("Welcome back");
      nav("/admin");
    } catch (err) {
      toast.error(err?.response?.data?.detail || "Login failed");
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="min-h-screen bg-[color:var(--admin-bg)] text-[color:var(--admin-text)] flex items-center justify-center px-6">
      <div className="w-full max-w-md">
        <Link to="/" data-testid="back-home-link" className="text-xs uppercase tracking-widest text-[color:var(--admin-amber)] hover:underline">
          ← Back to site
        </Link>
        <div className="mt-6 border border-[color:var(--admin-border)] p-10">
          <div className="flex items-center gap-3">
            <img src="/logo.jpeg" alt="Bawajii" className="h-12 w-12 rounded-full object-cover" />
            <div className="flex items-center gap-2 text-[color:var(--admin-amber)]">
              <Lock className="h-4 w-4" />
              <span className="text-xs uppercase tracking-[0.2em]">Admin Access</span>
            </div>
          </div>
          <h1 className="font-display text-4xl mt-3">Sign in</h1>
          <p className="text-sm text-neutral-400 mt-2">Bawajii Travels &amp; Infra — dashboard</p>

          <form onSubmit={submit} className="mt-8 space-y-5" data-testid="admin-login-form">
            <div>
              <Label htmlFor="ae" className="text-neutral-300">Email</Label>
              <Input
                id="ae"
                type="email"
                data-testid="login-email-input"
                value={email}
                onChange={(e) => setEmail(e.target.value)}
                required
                className="mt-1 bg-[color:var(--admin-surface)] border-[color:var(--admin-border)] text-white"
              />
            </div>
            <div>
              <Label htmlFor="ap" className="text-neutral-300">Password</Label>
              <Input
                id="ap"
                type="password"
                data-testid="login-password-input"
                value={password}
                onChange={(e) => setPassword(e.target.value)}
                required
                className="mt-1 bg-[color:var(--admin-surface)] border-[color:var(--admin-border)] text-white"
              />
            </div>
            <Button
              type="submit"
              disabled={loading}
              data-testid="login-submit-btn"
              className="w-full rounded-none bg-[color:var(--admin-amber)] hover:bg-amber-400 text-black font-semibold py-6"
            >
              {loading ? <Loader2 className="h-4 w-4 animate-spin mr-2" /> : null}
              Sign in
            </Button>
          </form>
        </div>
      </div>
    </div>
  );
};

export default AdminLogin;
